import type { Dictionnaire } from '../type';

export const lieux: Dictionnaire['lieux'] = {
  carte: 'Mapa de lugares',
  filtrer: 'Filtrar lugares',
  tout: 'Todo',
  rapproche: 'Acércate para ver los lugares',
  recherche: 'Buscando lugares…',
  fermer: 'Cerrar',
  appeler: 'Llamar',
  chercherSurLeWeb: 'Buscar en la web',
  chercher: 'Busca un tipo de actividad',
  exemple: 'Piscina, estadio…',
  effacer: 'Borrar',
  rienTrouve: 'No se ha encontrado nada por aquí',
  creerUnEvenement: 'Crear un evento aquí',
  aimer: 'Me gusta este lugar',
  nePlusAimer: 'Ya no me gusta este lugar',
  familles: {
    restos: 'Comer',
    sorties: 'Salir',
    sport: 'Deporte',
    culture: 'Cultura',
    nature: 'Naturaleza',
    commerces: 'Tiendas',
  },
  categories: {
    Restaurant: 'Restaurante',
    Cafe: 'Cafetería',
    Bakery: 'Panadería',
    Nightlife: 'Bar',
    Brewery: 'Cervecería',
    Winery: 'Bodega',
    Distillery: 'Destilería',
    MovieTheater: 'Cine',
    Theater: 'Teatro',
    MusicVenue: 'Sala de conciertos',
    Bowling: 'Bolera',
    MiniGolf: 'Minigolf',
    GoKart: 'Karting',
    AmusementPark: 'Parque de atracciones',
    Stadium: 'Estadio',
    Soccer: 'Fútbol',
    Tennis: 'Tenis',
    Basketball: 'Baloncesto',
    Swimming: 'Piscina',
    Volleyball: 'Voleibol',
    Golf: 'Golf',
    Skating: 'Pista de patinaje',
    RockClimbing: 'Escalada',
    SkatePark: 'Skatepark',
    FitnessCenter: 'Gimnasio',
    Museum: 'Museo',
    Landmark: 'Monumento',
    Castle: 'Castillo',
    Fortress: 'Fuerte',
    NationalMonument: 'Monumento nacional',
    Library: 'Biblioteca',
    Planetarium: 'Planetario',
    Aquarium: 'Acuario',
    Zoo: 'Zoo',
    Park: 'Parque',
    Beach: 'Playa',
    Hiking: 'Senderismo',
    NationalPark: 'Parque nacional',
    Marina: 'Puerto deportivo',
    Store: 'Tienda',
    FoodMarket: 'Mercado',
  },
};
